<div class="flex min-h-screen items-center justify-center px-4 py-8">
  <div class="flex w-full max-w-md flex-col gap-6">
    <app-logo [widthInPx]="120" />

    <div hlmCard>
      @switch (state()) {
        @case ('confirming') {
          <div hlmCardContent class="flex flex-col items-center gap-3 py-10 text-center">
            <hlm-spinner class="text-[length:--spacing(8)]" />
            <p hlmMuted class="text-sm">Neue IBAN wird bestätigt…</p>
          </div>
        }

        @case ('done') {
          <div hlmCardHeader>
            <h1 hlmCardTitle class="flex items-center gap-2">
              <ng-icon name="lucideCircleCheck" />
              IBAN bestätigt
            </h1>
            <p hlmCardDescription>
              Ab jetzt überweist dir deine Zentrale auf
              <span class="font-mono">{{ iban() }}</span
              >. Sie wurde über die Änderung informiert.
            </p>
          </div>
          <div hlmCardContent>
            <a
              hlmBtn
              class="w-full"
              [routerLink]="loggedIn ? ['/settings'] : ['/login']"
              [queryParams]="loggedIn ? { tab: 'bank-account' } : {}">
              {{ loggedIn ? 'Zur Bankverbindung' : 'Zum Login' }}
            </a>
          </div>
        }

        @case ('error') {
          <div hlmCardHeader>
            <h1 hlmCardTitle>IBAN nicht bestätigt</h1>
          </div>
          <div hlmCardContent class="space-y-4">
            <div hlmAlert variant="destructive">
              <ng-icon name="lucideTriangleAlert" />
              <p hlmAlertTitle>{{ errorMessage() }}</p>
              <p hlmAlertDescription>Deine bisherige IBAN bleibt unverändert.</p>
            </div>
            <a hlmBtn variant="outline" class="w-full" routerLink="/">Zum Dashboard</a>
          </div>
        }
      }
    </div>
  </div>
</div>
